/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserNotificationDto
 */
export interface UpdateUserNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserNotificationDto
     */
    text: string | null;
}

export function UpdateUserNotificationDtoFromJSON(json: any): UpdateUserNotificationDto {
    return UpdateUserNotificationDtoFromJSONTyped(json, false);
}

export function UpdateUserNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function UpdateUserNotificationDtoToJSON(value?: UpdateUserNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}


